import { ZIPCODE_FETCH_SUCCESS } from '_acaSrc/utility/constants';
import UtdRestClient from '_acaSrc/utility/http/UtdRestClient';

export default function zipLocationService() {
    const fetchCityStateFromZip = async(zipCode) => {
        const zipCodeUrl = `/services/ZipCodeCities?zipcode=${zipCode}`;
        const zipData = await UtdRestClient.getCustom(zipCodeUrl);
        const data = JSON.parse(zipData.data);

        if (data.STATUS === ZIPCODE_FETCH_SUCCESS) {
            const citiesCounties = data.FIPSZIP.cities;
            const citiesList = citiesCounties.map((city, idx) => {
                return {
                    label: city.name,
                    value: idx
                };
            });
            if (citiesList.length === 0) {
                return { status: data.STATUS, selectedState: '', citiesList: [], county: '' };
            }
            const countiesList = citiesCounties.map(city => city.counties);

            const selectedState = countiesList[0][0].state;
            const county = countiesList[0][0].fips;
            return { status: data.STATUS, selectedState, citiesList, county };
        }
        return {};
    };

    return {
        fetchCityStateFromZip
    };
}